import * as React from 'react'

import { SVGResponsive } from './common'

function PaySchedule() {
  return (
    <SVGResponsive height={24} width={24}>
      <path
        d="M21.3867 6.48157L20.5188 10.3863L16.6141 9.51841"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.49 15C18.158 18.7808 14.4862 21.2248 10.4843 20.9945C6.48241 20.7642 3.11523 17.915 2.22578 14.0064C1.33633 10.0978 3.13903 6.07214 6.64717 4.1328C10.1553 2.19346 14.5232 2.808 17.36 5.64004C19 7.27726 20 9.5 20 9.5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.8959 16.16C12.5919 16.16 13.9999 15.424 13.9999 13.776C13.9999 12.272 13.0079 11.632 11.6159 11.28L10.8639 11.088C10.0959 10.88 9.5519 10.736 9.5519 10.176C9.5519 9.66397 9.9839 9.35997 10.6079 9.35997C11.0408 9.35997 11.373 9.47662 11.5922 9.6855C11.8761 9.95609 12.1799 10.288 12.5722 10.288C13.2628 10.288 13.8302 9.66046 13.4494 9.08439C12.9648 8.35145 12.0413 7.83997 10.5919 7.83997C9.0079 7.83997 7.5999 8.68797 7.5999 10.288C7.5999 11.856 8.8159 12.288 9.8879 12.544L10.6399 12.736C11.5039 12.96 12.0479 13.216 12.0479 13.824C12.0479 14.4 11.5039 14.64 10.8799 14.64C10.2801 14.64 9.77544 14.4584 9.50561 14.0192C9.32148 13.7194 9.0486 13.44 8.69679 13.44H8.62823C7.93346 13.44 7.35084 14.0586 7.68463 14.668C8.19535 15.6003 9.26577 16.16 10.8959 16.16Z"
        fill="#9A9A9A"
      />
      <path
        d="M9.68848 7.5C9.68848 6.94772 10.1362 6.5 10.6885 6.5C11.2408 6.5 11.6885 6.94772 11.6885 7.5V8H9.68848V7.5Z"
        fill="#9A9A9A"
      />
      <path
        d="M11.6885 16.5C11.6885 17.0523 11.2408 17.5 10.6885 17.5C10.1362 17.5 9.68848 17.0523 9.68848 16.5L9.68848 16L11.6885 16L11.6885 16.5Z"
        fill="#9A9A9A"
      />
    </SVGResponsive>
  )
}

export default React.memo(PaySchedule)
